import React from 'react';
import { connect } from 'react-redux';
import { fetchHistoryModel } from './HistoryBlock.action';
import HistoryBlock from './HistoryBlock';

class HistoryBlockContainer extends React.Component {
    constructor(props) {
        super(props);
        this.props.fetchData(this.props.blockId);
    }
    render() {
        return (
            <HistoryBlock {...this.props} />
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        fetchData: (blockId) => dispatch(fetchHistoryModel(blockId))
    }

}
const mapStateToProps = state => {
    return {
        result: state.HistoryReducer.result,
        innerWidth: state.browserSize.innerWidth,
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(HistoryBlockContainer);